import type { ObjectStoreName } from '@/types/accessor/indexedDB'

/**
 * session storage保存
 * @param key オブジェクト名
 * @param value 登録する内容
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function setItem(key: ObjectStoreName, value: any): void {
  sessionStorage.setItem(key, JSON.stringify(value))
}

/**
 * session storage取得
 * @param key オブジェクト名
 * @returns 対象のstorage内容
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getItem(key: ObjectStoreName): any {
  const item = sessionStorage.getItem(key)
  return item ? JSON.parse(item) : null
}

/**
 * session storage削除
 * @param key オブジェクト名
 */
export function removeItem(key: ObjectStoreName): void {
  sessionStorage.removeItem(key)
}
